import { deleteRequest, fetchRequest, postRequest } from 'services/api.service';
import { RatingFeedbackResponse, ConciergeActions, CreateNote } from 'typings';

export async function activateConcierge() {
  await postRequest('/activate');
}

export async function deactivateConcierge(reason?: string) {
  await postRequest('/deactivate', { reason });
}

export async function fetchConcierge() {
  return fetchRequest('');
}

export async function fetchConciergeAssignedLead() {
  return fetchRequest('/assigned-lead');
}

export async function loginConcierge(token: any) {
  return postRequest('/login', { token }, { withCredentials: true });
}

export async function logoutConcierge() {
  await postRequest('/logout', {}, { withCredentials: true });
}

export async function renewAuthConcierge() {
  return postRequest('/renew-auth', {}, { withCredentials: true });
}

export async function createMessage(type: string, payload: any) {
  switch (type) {
    case ConciergeActions.EMAIL:
      await postRequest('/emails', payload);
      break;
    case ConciergeActions.SMS:
      await postRequest('/messages', payload);
      break;
    default:
      return {};
  }
}

export async function createNote(payload: CreateNote) {
  await postRequest('/notes', payload);
}

export async function flagMessage(messageId: number) {
  await postRequest(`/messages/${messageId}/flag`);
}

export async function unflagMessage(messageId: number) {
  await deleteRequest(`/messages/${messageId}/flag`);
}

export async function rateActivity(data: any) {
  await postRequest('/ratings', data);
}

export async function reportEmailIssue(emailId: number) {
  await postRequest(`/emails/${emailId}/issue`);
}

export async function removeEmailIssue(emailId: number) {
  await deleteRequest(`/emails/${emailId}/issue`);
}

export async function reportMessageIssue(messageId: number) {
  await postRequest(`/messages/${messageId}/issue`);
}

export async function removeMessageIssue(messageId: number) {
  await deleteRequest(`/messages/${messageId}/issue`);
}

export async function sendConciergeActivity() {
  await postRequest('/ping');
}

export async function fetchUnreviewedRatingFeedback() {
  return fetchRequest('/ratings/filter/unreviewed');
}

export async function replyRatingFeedback(payload: RatingFeedbackResponse) {
  await postRequest(`/ratings/${payload.conciergeRatingId}/review`, {
    ...payload,
    conciergeRatingId: undefined,
  });
}
